var config = window.__config;

function getAssetUrl(relativePath) {
  throw new Error('This method is not supported in the browser.');
}

function getImageUrl(relativePath) {
  relativePath = removeLeadingSlash(relativePath);
  if (!config.deployed_assets) return '/new-web-local/' + relativePath;

  relativePath = convertLocalPathToProdPath(relativePath);
  return config.static_assets + '/' + relativePath;
}

function convertLocalPathToProdPath(relativePath) {
  return relativePath.replace(/^\/(sass|jsx|image)\//, '');
}

function removeLeadingSlash(relativePath) {
  return relativePath.replace(/^\//, '');
}

module.exports = {
  getAssetUrl: getAssetUrl,
  getImageUrl: getImageUrl
};
